
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website, WebsiteComposite } from '@/services/Website/interfaces';

export interface FtpManageUser {
  id: number;
  username: string;
  homeDir?: string;
}

export interface FtpManageData {
  users?: FtpManageUser[];
  ftpError?: string;
}

@Component
export default class FtpManagePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  @Prop({ type: Object, default: () => ({}) })
  public panelData!: FtpManageData;

  public confirmDeleteId: number | null = null;

  public confirmInput: string = '';

  public editPasswordId: number | null = null;

  public editPasswordValue: string = '';

  public createFormValid: boolean = false;

  public createUsername: string = '';

  public createPassword: string = '';

  public createHomeDir: string = '';

  public get website(): Website {
    return this.composite.website;
  }

  public get users(): FtpManageUser[] {
    return (this.panelData && this.panelData.users) || [];
  }

  public get confirmValid(): boolean {
    return this.confirmDeleteId !== null
      && this.confirmInput.trim().toLowerCase() === this.website.domain.toLowerCase();
  }

  public get canCreate(): boolean {
    return this.createFormValid
      && !!this.createUsername
      && !!this.createPassword
      && !!this.createHomeDir;
  }

  public requiredRule(value: string): boolean | string {
    return !!value || 'Required';
  }

  public startDelete(userId: number): void {
    this.confirmDeleteId = userId;
    this.confirmInput = '';
  }

  public cancelDelete(): void {
    this.confirmDeleteId = null;
    this.confirmInput = '';
  }

  public confirmDelete(): void {
    if (!this.confirmValid || this.confirmDeleteId === null) {
      return;
    }
    const userId = this.confirmDeleteId;
    this.cancelDelete();
    this.emitSubmit('delete', { userId });
  }

  public startEditPassword(userId: number): void {
    this.editPasswordId = userId;
    this.editPasswordValue = '';
  }

  public cancelEditPassword(): void {
    this.editPasswordId = null;
    this.editPasswordValue = '';
  }

  public confirmEditPassword(): void {
    if (!this.editPasswordValue || this.editPasswordId === null) {
      return;
    }
    const userId = this.editPasswordId;
    const password = this.editPasswordValue;
    this.cancelEditPassword();
    this.emitSubmit('update', { userId, password });
  }

  public submitCreate(): void {
    if (!this.canCreate) {
      return;
    }
    this.emitSubmit('create', {
      username: this.createUsername,
      password: this.createPassword,
      homeDir: this.createHomeDir,
    });
    this.createUsername = '';
    this.createPassword = '';
    this.createHomeDir = '';
  }

  public emitSubmit(operation: string, payload: Record<string, unknown> = {}): void {
    this.$emit('submit', { operation, ...payload });
  }
}
